<template>
  <div class="application">
    <transition name="fade">
      <intro-section
        v-if="step == 1"
        title="Welcome to EqueFi"
        body="We're looking forward to working together. Our job is to provide you with options as unique as your business. To do this, we need to learn a little bit more about you."
        btn_text="Get Started"
        icon="high5"
        v-on:next="next(2)"
      ></intro-section>
    </transition>

    <template>
      <progress-bar
        v-if="step > 1 || step == null"
        :questions_total="total_questions"
        :question_num="previous_step - 1"
        phase="Application Approval"
        :category_label="questions[previous_step - 1].category"
      ></progress-bar>

      <transition name="fade">
        <div class="questions" v-if="step > 1">
          <questions
            :step="step"
            question_title="start"
            :questions="questions"
            v-on:saveAnswer="saveAnswer"
          ></questions>
        </div>
      </transition>
    </template>

    <transition name="fade">
      <saving-info
        v-if="save_info_screen"
        title="Analyzing Financial Information"
        body="Please wait a moment while we analyze your profile. Equfi will never sell your data to unscrupulous third party resellers. At Equfi we take the security of our data seriously"
      ></saving-info>
    </transition>
  </div>
</template>

<script>
import { db, functions, auth } from "@/config/firebaseInit";
import firebase from "firebase";
import Section from "@/components/Application/Section";
import Progress from "@/components/Application/Progress";
import Questions from "@/components/Application/Questions";
import QuestionsList from "@/components/Application/Questions.json";
import SavingInfo from "@/components/Application/SavingInfo";

export default {
  name: "Start",
  components: {
    "intro-section": Section,
    "progress-bar": Progress,
    questions: Questions,
    "saving-info": SavingInfo
  },
  data() {
    return {
      answers: {},
      save_info_screen: false,
      step: this.$store.state.application_approval_step,
      previous_step: 1,
      questions: QuestionsList["start"],
      total_questions: 0,
      sendEmail: functions.httpsCallable("sendEmail")
    };
  },
  created() {
    let questions = 0;
    for (var key in QuestionsList) {
      questions += QuestionsList[key].length;
    }
    this.total_questions = questions;
    if (this.step > 1) {
      this.previous_step = this.step - 1;
    }
  },
  methods: {
    next(step) {
      this.step = null;
      setTimeout(() => {
        this.step = step;
      }, 500);
    },
    saveAnswer(name, answer) {
      this.answers[name] = answer;
    },
    saveData() {
      this.save_info_screen = true;
      let data = {
        start: this.answers,
        created_at: Date.now(),
        status: "about",
        phase: "Application Approval"
      };
      this.$store.commit("setUser", data);
      db.collection("user")
        .doc(this.$store.state.user_id)
        .set(data, { merge: true })
        .then(doc => {
          this.sendRegisterEmail();
          setTimeout(() => {
            this.$parent.step = null;
            setTimeout(() => {
              this.$parent.step = "about";
            }, 500);
          }, 7000);
        });
    },
    sendRegisterEmail() {
      let vm = this;
      let user = vm.$store.state.user;
      return Promise.all([
        this.sendEmail({
          template_name: "equfi-register-link",
          subject: "Time to Register!",
          from_email: null,
          to_email: [
            {
              email: user.start.email,
              type: "to"
            }
          ],
          global_merge_vars: [
            {
              name: "name",
              content: user.start.full_name
            },
            {
              name: "register_url",
              content:
                "https://equfiloans.com/register/" + vm.$store.state.user_id
            }
          ]
        })
      ]);
    }
  }
};
</script>

<style lang="scss">
.intro {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
    }
    h1 {
      font-size: 50px;
    }
  }
}

.questions {
  max-width: 450px;
  width: 100%;
  margin: auto;
  margin-top: 30px;
}
</style>
